import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { z } from "zod";
import type { Database } from "@base-hormonal/database";

const publicConfigSchema = z
  .object({
    url: z.url().refine((url) => url.startsWith("https://"), "HTTPS obrigatorio"),
    publishableKey: z.string().startsWith("sb_publishable_").min(24),
  })
  .strict();

export type TypedSupabaseClient = SupabaseClient<Database>;

export function createSupabaseClient(config: unknown): TypedSupabaseClient | null {
  const parsed = publicConfigSchema.safeParse(config);
  if (!parsed.success) return null;
  return createClient<Database>(parsed.data.url, parsed.data.publishableKey, {
    auth: {
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: "pkce",
      persistSession: true,
    },
  });
}

export const localSupabaseClient = createSupabaseClient({
  url: import.meta.env.VITE_SUPABASE_URL,
  publishableKey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
});
